module.exports = __webpack_public_path__ + "static/media/11.a037acd3.jpg";